import React, {Component} from 'react'
import Axios from 'axios'
import {message, Avatar, Input, Button, List, Pagination} from 'antd'
import moment from 'moment'
import Header4 from 'src/components/Header/Header4'
import icon_avatar from './img/icon_avatar.png'
import icon_comment from './img/icon_comment.png'
import icon_up from './img/icon_up.png'
import './QAdetail.css'
import {connect} from "react-redux"
import {DeleteOutlined} from "@ant-design/icons";
import axios from "axios";
import {JudgingSpeech} from "./JudgingSpeech"

const {TextArea} = Input;


class QAdetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            list: [],
            length: '0/500',
            commentValue: '',
            currentPage: 1,
            totalPage: null
        }
        this.postId = ''
    }

    componentWillMount() {
        var qid = this.props.location.pathname.replace('/Q&ADetail/', '');
        console.log(qid)
        if (!qid) {
            window.location.href = "/Q&ACenter"
        }
        this.postId = qid;
        this.loaddata(qid)

        // this.loaddatacommend(qid)
    }

    loaddata = (id, page = this.state.currentPage) => {
        Axios.get(global.url.wd + `/postV2/getListByPostId?limit=10&page=${page}&postId=` + id).then((response) => {
            var data = response.data.payload
            if (response.data.code == '200') {
                // data.avatar = global.yunguanChangeUrl + data.avatar
                this.setState({data: data, list: data.commentList.records, totalPage: data.comments, currentPage: page})
            } else {
                message.error(data.msg)
            }
        }).catch(() => {
        })
    }
    _commentClick = () => {
        if(JudgingSpeech(this.state.commentValue)) {
            message.error("请勿发表低俗、暴力、色情、政治、广告等违规信息！");
            return
        }
        this.commentclick(this.state.commentValue)
        this.setState({commentValue: '', length: '0/500'})
    }
    _renderItem = (item) => {

    }
    commentclick = (text, replyId = null) => {
        Axios.post(global.url.wd + "/commentV2/addComment", {
            "postId": this.state.data.postId,
            "commentBody": text,
            "userId": this.props.user.userId,
            "userName": this.props.user.userName,
            "replyId": replyId
        }).then((response) => {
            // debugger
            var data = response.data
            this.loaddata(this.state.data.postId)

        }).catch(() => {
        })
    }
    textchange = ({target: {value}}) => {
        if (value.length > 500) {
            value = value.substring(0, 500)
        }
        this.setState({commentValue: value, length: value.length + '/500'})

    }
    pageChange = page => {
        var qid = this.props.location.pathname.replace('/Q&ADetail/', '')
        this.loaddata(qid, page)
    }

    deleteComment = (item) => {
        axios.delete(global.url.wd + `/commentV2/delete?commentId=${item.commentId}`).then(
            res => {
                if (res.data.code === '200') {
                    message.success("删除成功！");
                    this.loaddata(item.postId);
                } else {
                    message.error(res.data.message);
                }
            }
        )
    }

    render() {
        let {data, currentPage, totalPage} = this.state;
        return (
            <div>
                <Header4></Header4>
                <div className='QAMain'>
                    <div className='QAdetailBody'>
                        <div onClick={() => this.props.history.goBack()}>
                            <span className='M-back'>{"<  返回上一级"}</span>
                        </div>
                        <div className='QAdetailTitle'>{data.postTitle}</div>
                        <div className='postType'>
                            <span className='postTypeText'>
                                {data.postType}
                            </span>
                        </div>
                        <div className='postBody'>
                            <Avatar src={data.avatar ? global.yunguanChangeUrl + data.avatar : icon_avatar}
                                    className='userAvatar'/>
                            <div className='post-content'>
                                <div className='userAndTime'>
                                    <div className='userName'>{data.userName}</div>
                                    <div className='postTime'>{data.createdTime}</div>
                                </div>
                                <div className='postText'>{data.postContent}</div>
                            </div>
                        </div>
                        <div className='funcBody'>
                            <img className='commentIcon' src={icon_comment}/>
                            <div className='commentsNum'
                                 style={{display: data.comments ? 'block' : 'none'}}>{data.comments}</div>
                            <div className='commentsText'>评论</div>
                        </div>
                        <div style={{width: '100%'}}>
                            {this.state.list.map(item => {
                                return (
                                    <CommitZone item={item} deleteFunction={this.deleteComment}
                                                commentSub={this.commentclick} commentItem={item}
                                                userId={this.props.user.userId}/>
                                )
                            })}
                        </div>
                        <div className='QAPagination'>
                            <Pagination
                                total={totalPage}
                                current={currentPage}
                                pageSize={10}
                                onChange={this.pageChange}
                            />;
                        </div>
                        <div className='mainCommit'>
                            <TextArea className='mainTextArea' value={this.state.commentValue} placeholder='输入评论……'
                                      style={{height: '20rem'}} onChange={this.textchange} maxLength={500}></TextArea>
                            <div className='mainCommitFuc'>
                                <div className='textLength'>{this.state.length}</div>
                                <Button className='subButton' onClick={() => this._commentClick()}>发布</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    user: state.userReducer.get('user').toJS()
})

export default connect(mapState)(QAdetail)

class CommitZone extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expandFlag: false,
            commentValue: '',
            length: 0,
            // item: {},
            // deleteFunction: {},
            // replyList: [],
        }
    }

    // componentDidMount() {
    //     let {item, deleteFunction} = this.props;
    //     this.setState({item: item, deleteFunction: deleteFunction, replyList: item.replyList});
    // }

    textchange = ({target: {value}}) => {
        
        if (value.length > 500) {
            value = value.substring(0, 500)
        }
        this.setState({commentValue: value, length: value.length + '/500'})

    }

    settext = (text) => {
        this.setState({commentValue: text, length: text.length + '/500'})
    }

    rcommentSub = () => {
        if(JudgingSpeech(this.state.commentValue)){
            message.error("请勿发表低俗、暴力、色情、政治、广告等违规信息！");
            return
        }
        this.props.commentSub(this.state.commentValue, this.props.commentItem.commentId)
        this.setState({
            commentValue: ''
        })
    }

    deleteCommentOfComment = (item) => {

    }

    render() {
        let {item, deleteFunction, userId} = this.props;
        let replyList = item.replyList;
        console.log( '当前评论的userId是否等于当前用户的userId', item.userId , userId,item);
        return (
            <div className='listItem'>
                {/*TODO：这里添加外层评论的删除逻辑*/}
                <div className='postBody' key={item.commentId}>
                    <Avatar src={item.avatar ? global.yunguanChangeUrl + item.avatar : icon_avatar}
                            className='userAvatar'/>
                    <div className='post-content'>
                        <div className='userAndTime'>
                            <div className='userName'>{item.userName}</div>
                            <div className='postTime'>{item.createdTime}</div>
                        </div>
                        <div className='postText'>{item.commentBody}</div>
                    </div>
                </div>
                <div className='mainBody'>
                    <div className='funcBody'>
                        {item.userId === userId ?
                            <Button danger type="text" icon={<DeleteOutlined/>}
                                    onClick={() => deleteFunction(item)}><span
                                style={{fontSize: "1.4rem"}}>删除</span></Button> : null}
                        <img className='commentIcon' src={icon_comment}
                             onClick={() => this.setState({expandFlag: !this.state.expandFlag})}/>
                        <div className='commentsNum'
                             style={{display: item.replyCount ? 'block' : 'none'}}>{item.replyCount}</div>
                        <div className='commentsText'>评论</div>
                        <img style={{display: this.state.expandFlag ? 'block' : 'none', cursor: 'pointer'}}
                             src={icon_up} onClick={() => this.setState({expandFlag: false})}/>
                    </div>
                    <div className='commentBody' style={{display: this.state.expandFlag ? 'block' : 'none'}}>
                        {replyList && replyList.map(ritem => {
                            console.log( '当前评论的userId是否等于当前用户的userId', ritem.userId === userId);
                            return (
                                // TODO:这里添加内层评论删除逻辑
                                <div className='postBody' key={ritem.commentId}>
                                    <Avatar src={ritem.avatar ? global.yunguanChangeUrl + ritem.avatar : icon_avatar}
                                            className='userAvatar'/>
                                    <div className='post-content'>
                                        <div className='userAndTime'>
                                            <div className='userName'>{ritem.userName}</div>
                                            <div className='postTime'>{ritem.createdTime}</div>
                                        </div>
                                        <div className='postText'>{ritem.commentBody}</div>
                                        <div className="comment_of_comment_delete_line">
                                            {ritem.userId === userId ?
                                                <Button danger type="text"
                                                        icon={<DeleteOutlined/>}
                                                        size="small"
                                                        onClick={() => deleteFunction(ritem)}
                                                        style={{fontSize: "1.3rem"}}>删除</Button> : null}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                        <TextArea value={this.state.commentValue} onChange={this.textchange}></TextArea>
                        <div style={{textAlign: 'right'}}>
                            <Button className='subButton' onClick={() => this.rcommentSub()}>发布</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}